import React from 'react';
import { useTranslation } from 'react-i18next';
import { currentLang } from '../../store/actions/support';

const ConsumptionTable = ({ consumptionData }) => {
    if (!consumptionData || !Array.isArray(consumptionData) || consumptionData.length === 0) {
        return null;
    }
    const { t, i18n } = useTranslation();

    // Gruppiere die Daten nach item.alphasort
    const groupedData = consumptionData.reduce((groups, item) => {
        const group = item.alphasort || 'fremdprodukt';
        if (!groups[group]) groups[group] = [];
        groups[group].push(item);
        return groups;
    }, {});

    // Definiere die gewünschte Gruppenreihenfolge
    const groupOrder = [
        'mineralfaserplatten',
        'moertel',
        'beschichtung',
        'fuellstoff',
        'manschette',
        'bandage',
        'fremdprodukt'
    ];


    // Sortiere die Gruppen nach Vorgabe, Rest ans Ende
    const sortedGroupNames = Object.keys(groupedData).sort((a, b) => {
        const idxA = groupOrder.indexOf(a);
        const idxB = groupOrder.indexOf(b);
        if (idxA === -1 && idxB === -1) return a.localeCompare(b);
        if (idxA === -1) return 1; // a nach hinten
        if (idxB === -1) return -1; // b nach hinten
        return idxA - idxB;
    });

    return (
        <div className="container-fluid">
        <br />
        <h4>{t('project_calculation_headline_consumption_table')}</h4>

        <table className="table">
            <thead>
                <tr>
                    <th>{t('project_calculation_table_col_headline_group')}</th>
                    <th>{t('project_calculation_table_col_headline_product')}</th>
                    <th>{t('project_calculation_table_col_headline_article')}</th>
                    <th>{t('project_calculation_table_col_headline_consumption')}</th>
                </tr>
            </thead>
            <tbody>
                {/* Gruppierte und sortierte Einträge anzeigen */}
                {sortedGroupNames.map((group) => (
                    <React.Fragment key={group}>
                        {/* Gruppenüberschrift */}
                        <tr>
                            <td colSpan="4" style={{ background: '#e9ecef', fontWeight: 'bold' }}>{t('grouping_headline_'+group)}</td>
                        </tr>
                        {/* Einträge der Gruppe, sortiert nach alphasort2 */}
                        {groupedData[group]
                            .slice()
                            .sort((a, b) => {
                                // Versuche numerisch zu sortieren, sonst alphabetisch
                                const aVal = isNaN(Number(a.alphasort2)) ? a.alphasort2 : Number(a.alphasort2);
                                const bVal = isNaN(Number(b.alphasort2)) ? b.alphasort2 : Number(b.alphasort2);
                                if (aVal < bVal) return -1;
                                if (aVal > bVal) return 1;
                                return 0;
                            })
                            .map((item, index) => (
                                <tr key={index}>
                                    <td></td>
                                    <td>{item.productgroup_title[currentLang()]}</td>
                                    <td>{item.productarticle_title[currentLang()]}</td>
                                    <td>{Math.round(item.consumption * 100) / 100} {t('units.' + item.unit + '.shortform')}</td>
                                </tr>
                            ))}
                    </React.Fragment>
                ))}
            </tbody>
        </table>

    </div>


    );
};

export default ConsumptionTable; 


// WEBPACK FOOTER //
// ./src/components/Shared/ConsumptionTable.js